<template>
  <div
    class="gxxt-tag"
    :class="classStr"
    :style="{'background': color, 'color': textColor}"
    @click="click"
  >
    <div class="flex">
      <slot></slot>
      <slot name="icon" v-if="$slots.icon">
        <span class="icon"></span>
      </slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    round: {
      type: Boolean,
      default: false,
    },
    color: {
      type: String,
      default: '#f5f5f5',
    },
    textColor: {
      type: String,
      default: '#888',
    },
    size: {
      type: String,
      default: 'middle',
    },
    value: {
      type: [String, Number],
      default: '',
    },
  },
  emits: ['click', 'change'],
  data() {
    return {
      classArr: [],
      classStr: '',
    }
  },
  mounted() {
    this.classUpdate()
  },
  beforeUpdate() {
    this.classUpdate()
  },
  methods: {
    classUpdate() {
      this.classStr = ''
      this.classArr = []
      this.disabled && this.classArr.push('disabled')
      this.round && this.classArr.push('round')
      this.classArr.push(this.size ? this.size : 'middle')
      this.classArr.push(this.type)
      this.classStr = this.classArr.join(' ')
    },
    change() {
      this.$emit('change', this.value)
    },
    click() {
      this.$emit('click', this.value)
    },
  },
}
</script>

<style scoped>
.gxxt-tag {
  display: inline-block;
  padding: 0 10px;
  background: #f5f5f5;
  color: #888;
  border-radius: 4px;
  font-size: 0;
  cursor: pointer;
}
.flex {
  flex: 1 0 0;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
.gxxt-tag.large {
  font-size: 22px;
  height: 46px;
}
.gxxt-tag.large.round {
  border-radius: 23px;
}
.gxxt-tag.middle {
  font-size: 22px;
  height: 36px;
}
.gxxt-tag.middle.round {
  border-radius: 18px;
}
.gxxt-tag.small {
  font-size: 22px;
  height: 32px;
}
.gxxt-tag.small.round {
  border-radius: 18px;
}
.gxxt-tag .icon {
  margin-left: 10px;
}
</style>